import Vue from 'vue'
import perfectScrollbar from 'perfect-scrollbar'
import _throttle from 'lodash.throttle'

Vue.directive('view-directive', {
    params: ['routeName'],

    bind: function () {
        // list of excluded routes name
        let excludedRoutes = ['home', 'about', 'view', 'graham']

        // about page as specific requirments
        if (!(excludedRoutes.includes(this.params.routeName))) {

            // Scrollbar Y axis init
            let scrollyMe = this.el.querySelectorAll('.scrolly-me-container')
            for (let i = 0; i !== scrollyMe.length; i++) {
                perfectScrollbar.initialize(scrollyMe[i], {
                    suppressScrollX: true
                })
            }

            // Windows resize
            window.addEventListener('resize', _throttle(function () {
                for (let i = 0; i !== scrollyMe.length; i++) {
                    perfectScrollbar.update(scrollyMe[i])
                }
            }, 400))

            // force resize
            setTimeout(function () {
                let event = document.createEvent('CustomEvent')
                event.initCustomEvent('resize', true, true, {})
                window.dispatchEvent(event)
            }, 400)
        }

        // SVG not supported => fallback PNG
        let isIE = this.vm.isBrowserIE
        if (isIE || !Modernizr.svg) {
            let imgs = this.el.querySelectorAll('[data-fallback-src]')
            for (let i = 0; i !== imgs.length; i++) {
                imgs[i].src = imgs[i].getAttribute('data-fallback-src')
                imgs[i].removeAttribute('data-fallback-src')
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/custom/directives.js